import React from "react";
import Cards from "../components/Card/Cards";
import "./Home.css";


const Home = () => {
  return (
    <div>
      <section className="py-8">
        <Cards />
      </section>
      
    </div>
  );
};

export default Home;
